// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"b3661849","703":"01860555","787":"80a98667"}[chunkId] + ".chunk.js";
};